export const dataProperties = {
  headline: 'headline',
  description: 'description',
};

export const headlineMaxCount = 55;
export const descriptionMaxCount = 155;
